<template>
  <div class="Zoom">

    <form @submit.prevent="setToken">
      <label>
        <span>Zoom API token</span>
        <input v-model="tokenTemp" :disabled="!enabled" placeholder="Zoom API token"/>
        <button type="submit" :disabled="!enabled">Connect</button>
      </label>
    </form>
    <span class="info" :class="{'red': !zoom.state, 'green': zoom.state}">
      {{stateString}}
    </span>

  </div>
</template>

<script>
// @ is an alias to /src

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Zoom',
  components: {
  },
  data: function () {
    return {
      tokenTemp: ''
    }
  },
  computed: {
    ...mapState('apis',[
      'zoom'
    ]),
    enabled: function () {
      return this.isAdmin || this.isDemo
    },
    stateString: function () {
      if(this.enabled){
        if(this.zoom.state == false){
          return "Could not connect"
        }
        else if(this.zoom.state == true){
          return "Connected to zoom meeting"
        }
        else {
          return "Not connected"
        }
      }
      else {
        return "Enabled for the Textify room host only"
      }
    },
    ...mapGetters('socket',[
      'isAdmin',
      'isDemo'
    ]),
  },
  methods: {
    setToken: function () {
      this.$store.dispatch('apis/setZoomToken',{token: this.tokenTemp})
    }
  },
  mounted: function () {
    this.tokenTemp = this.zoom.token
  }
}
</script>

<style lang="scss" scoped>

.columns{
  flex-wrap: wrap;
}

.columns > div{
  flex: 1 0 200px;
  margin-right: 10px;
}

</style>
